import { useHistory, useLocation } from "react-router-dom";
import { toast } from "@jsq/ds/core";
import { useCreatePaymentAccountMutation } from "~/graphql/supergraphHooks";
import { type PaymentAccountInput } from "~/graphql/supergraphTypes";
import { BeneficiaryAccountModal } from "../BeneficiaryAccountModal";
import { usePaymentInstructions } from "../PaymentInstructionsContext";

const CreatePaymentBeneficiary = () => {
  const { caseId } = usePaymentInstructions();
  const history = useHistory();
  const location = useLocation();

  const baseUrl = `${location.pathname.split("/create")[0]}`;

  const [createPaymentAccountMutation] = useCreatePaymentAccountMutation({
    fetchPolicy: "network-only",
    onError: (e) => {
      toast.error(e.message);
      throw e;
    },
    refetchQueries: ["GetInvestorBankDetails", "GetCaseInvestingProfileRiskRating"],
    awaitRefetchQueries: true,
  });

  const handleSubmit = async (requestBody: PaymentAccountInput) => {
    await createPaymentAccountMutation({
      variables: { caseId, data: requestBody },
    });
    toast.success("Bank account created");
    history.push(baseUrl);
  };
  return (
    <BeneficiaryAccountModal
      title="Create payment beneficiary"
      handleSubmit={handleSubmit}
      handleNavigateBack={() => history.push(baseUrl)}
    />
  );
};

export default CreatePaymentBeneficiary;
